export interface FighterTypeCharacteristics {
    m: number;
    ws: number;
    bs: number;
    s: number;
    t: number;
    w: number;
    i: number;
    a: number;
    ld: number;
    cl: number;
    wp: number;
    int: number;
}

export interface FighterTypeDict {
    id: string;
    name: string;
    cost: number;
    factionId: string | null;
    factionName: string | null;
    fighterTypeEnum: number;
    isBase: boolean;
    canEquipStandardWargear: boolean;
    startingLevel: number;
    commonStatus: number;
    characteristics: FighterTypeCharacteristics;
}

export interface CreateFighterTypeDto {
    name: string;
    cost: number;
    factionId: string | null;
    fighterTypeEnum: number;
    isBase: boolean;
    canEquipStandardWargear: boolean;
    startingLevel: number;
    characteristics: FighterTypeCharacteristics;
}

export type UpdateFighterTypeDto = CreateFighterTypeDto;

export const FIGHTER_TYPE_ENUM_LABELS: Record<number, string> = {
    1: "Juve",
    2: "Ganger",
    3: "Specialist",
    4: "Champion",
    5: "Leader",
    6: "Brute",
    7: "Pet",
    8: "Hanger-On",
};
